import { LandingLayout } from '@/components/landing/LandingLayout';
import { Helmet } from 'react-helmet-async';

const Privacy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - Rental Manager</title>
        <meta name="description" content="Privacy policy for Rental Manager property management platform." />
      </Helmet>

      <LandingLayout>
        <section className="py-16 container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
          
          <div className="prose prose-slate max-w-none space-y-6">
            <p className="text-muted-foreground">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>

            <h2 className="text-2xl font-bold mt-8">Who We Serve</h2>
            <p className="text-muted-foreground">
              Rental Manager is built for short-term rental hosts with 1–50 active listings. 
              We help small Airbnb hosts and vacation rental operators manage turnovers, cleanings, 
              and bookings without enterprise PMS complexity.
            </p>

            <h2 className="text-2xl font-bold mt-8">Data We Collect</h2>
            <p className="text-muted-foreground">
              We collect property information, booking details, cleaner schedules, turnover records, 
              and account details necessary to coordinate short-term rental operations. We do NOT 
              process tenant payments or handle financial transactions — we provide tracking and 
              scheduling tools only.
            </p>

            <h2 className="text-2xl font-bold mt-8">Data Storage & GDPR Compliance</h2>
            <p className="text-muted-foreground">
              All data is stored in EU data centers (Frankfurt, Germany) with encryption at rest 
              and in transit. We are fully GDPR-compliant and follow European data protection standards. 
              We implement Row-Level Security (RLS) policies to ensure each user can only access their 
              own data.
            </p>

            <h2 className="text-2xl font-bold mt-8">Geographic Restrictions</h2>
            <p className="text-muted-foreground">
              This service is available in select regions. Geographic access restrictions may apply 
              based on local regulations and our data sovereignty commitments. All data is hosted in 
              EU (Frankfurt) data centers with GDPR compliance.
            </p>

            <h2 className="text-2xl font-bold mt-8">Data Sharing</h2>
            <p className="text-muted-foreground">
              We do not sell or share your data with third parties for marketing purposes. Your property 
              data, booking information, and cleaner schedules remain private and are never shared with 
              external parties except as required by law.
            </p>

            <h2 className="text-2xl font-bold mt-8">Your Rights</h2>
            <p className="text-muted-foreground">
              Under GDPR, you have the right to access, modify, export, or delete your data at any time. 
              You can manage your data through your account settings or by contacting support. We respond 
              to data access requests within 30 days as required by GDPR.
            </p>

            <h2 className="text-2xl font-bold mt-8">Minimal PII Exposure</h2>
            <p className="text-muted-foreground">
              We minimize personally identifiable information (PII) exposure by not processing payments 
              or storing sensitive financial data. We only track booking schedules, property details, 
              and operational information necessary for turnover coordination.
            </p>

            <h2 className="text-2xl font-bold mt-8">Cookie Policy</h2>
            <p className="text-muted-foreground">
              We use essential cookies to maintain your login session and ensure the service functions correctly. 
              We also use analytics cookies (Google Analytics 4) to understand how users interact with our service 
              and improve the user experience. You can manage cookie preferences through your browser settings or 
              our cookie consent banner. We do NOT use advertising or tracking cookies from third parties.
            </p>
            <p className="text-muted-foreground mt-4">
              <strong>Essential cookies:</strong> Session authentication, CSRF protection, language preference.<br />
              <strong>Analytics cookies:</strong> Google Analytics 4 (anonymized IP, deferred loading, GDPR-compliant).<br />
              <strong>Cookie retention:</strong> Session cookies expire when you close your browser. Persistent cookies 
              are stored for a maximum of 90 days.
            </p>

            <h2 className="text-2xl font-bold mt-8">Contact & Company Information</h2>
            <p className="text-muted-foreground">
              <strong>Service operated by:</strong> Shift Box Solutions UG<br />
              <strong>Data hosting:</strong> EU (Frankfurt, Germany)<br />
              <strong>Data Protection Officer:</strong> privacy@rental.shift-box.com<br />
              <strong>General Support:</strong> support@rental.shift-box.com
            </p>
            <p className="text-muted-foreground mt-4">
              ⚠️ <strong>Important:</strong> Geographic restrictions may apply based on local regulations. 
              For questions, contact: privacy@rental.shift-box.com
            </p>
          </div>
        </section>
      </LandingLayout>
    </>
  );
};

export default Privacy;
